export default function WhatIsSection() {
  return (
    <section id="what-is" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 mb-5">
            <span className="text-xs font-medium text-primary-700 tracking-wide">About</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            What Is Sugargoo Spreadsheet?
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            <strong className="text-foreground-900">Sugargoo Spreadsheet</strong> is a structured product discovery resource that helps shoppers organize products, compare options, and find trending items faster. Instead of manually searching through thousands of individual product listings, users can explore categorized spreadsheets that contain carefully curated finds with detailed information.
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            Each spreadsheet entry includes product categories, price references, seller ratings, quality assessment tips, and personalized shopping recommendations. Whether you are looking for the latest sneaker releases, trending hoodies, or premium accessories, the Sugargoo Spreadsheet database streamlines your entire product research workflow.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
            {[
              { icon: 'ri-price-tag-3-line', text: 'Product Categories &amp; Organization' },
              { icon: 'ri-money-dollar-circle-line', text: 'Price References &amp; Comparisons' },
              { icon: 'ri-store-2-line', text: 'Seller Information &amp; Ratings' },
              { icon: 'ri-shield-check-line', text: 'Quality Tips &amp; Recommendations' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200/40">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                  <i className={`${item.icon} text-accent-600 text-sm`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="text-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Explore Latest Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}